import { jsx as _jsx } from "react/jsx-runtime";
import { useStore } from 'react-redux';
import { setSearchString } from '../../../../../app/engagement/actions';
import styles from './styles.module.scss';
import { getViewerIdAndKind, useSession } from '../../../../infra/session';
import { useApiQuery } from '../../../../infra/api';
import { endpoints as campaignEndpoints } from '../../network';
import { SearchInput } from '../../../../infra/ui/search-input';
import { useReduxSelector } from '../../../../infra/redux-bridge';
export var CampaignSearchInput = function () {
    var _a;
    var session = useSession().data;
    var store = useStore();
    var viewerIdAndKind = getViewerIdAndKind(session);
    var initialValue = useReduxSelector('engagement.searchString');
    var campaigns = useApiQuery({
        endpoint: campaignEndpoints.campaignsQuery,
        payload: {
            ownerType: viewerIdAndKind === null || viewerIdAndKind === void 0 ? void 0 : viewerIdAndKind.kind,
            ownerId: viewerIdAndKind === null || viewerIdAndKind === void 0 ? void 0 : viewerIdAndKind.id,
            page: 1,
            perPage: 1,
        },
        options: {
            enabled: !!viewerIdAndKind,
        },
    });
    var showSearchInput = !campaigns.isFetching && ((_a = campaigns.data) === null || _a === void 0 ? void 0 : _a.list.length) > 0;
    var setCampaignFilter = function (value) { return store.dispatch(setSearchString(value)); };
    if (!showSearchInput) {
        return null;
    }
    return (_jsx("div", { className: styles['search-container'], children: _jsx("div", { className: "c-search-input", children: _jsx(SearchInput, { className: "c-search-input-component", name: "campaign-list-search-input", placeholder: "Search campaigns...", showIcon: true, setSearchTerm: setCampaignFilter, initialValue: initialValue }) }) }));
};
